import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import store from './store'
import ElementUI from 'element-ui';
Vue.use(ElementUI);

import './assets/icon/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'vis-network/styles/vis-network.min.css';
import VueResource from 'vue-resource';//大屏滚动效果
Vue.use(VueResource)

import VueCodeMirror from 'vue-codemirror';//在线编译器
import 'codemirror/lib/codemirror.css'
Vue.use(VueCodeMirror);

Vue.config.productionTip = false

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import qs from 'qs';
Vue.prototype.$qs = qs

import VueCron from 'vue-cron'
Vue.use(VueCron);

import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies

import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载
const i18n = new VueI18n({
    locale: 'zh',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
      'zh': require('./assets/zh'),   // 中文语言包
      'en': require('./assets/en')    // 英文语言包
    }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js